// ============================================================
// noEmail.ts — B3 (B2c item 3): "Client has no email address".
// Client.hasEmailAddress / Case.clientHasEmailAddress === false → the email
// isn't required (utils/validation), its box is disabled, and email features
// (bill sending — components/billing) say NO_EMAIL_ON_FILE instead. null =
// not answered (the email is required as before). Same pattern as hasNiNumber.
// ============================================================
export const NO_EMAIL_ON_FILE = 'No email address on file'
export const NO_EMAIL_LABEL = 'Client has no email address'
export const hasNoEmail = (p: { hasEmailAddress?: boolean | null } | null | undefined): boolean => p?.hasEmailAddress === false

// B3 — bill email consent (same wording as backend lib/billDelivery; the
// server is the gate, these mirror it in the send dialog).
export const NO_EMAIL_CONSENT = 'No email consent for this address. Record consent or send by post.'
export const consentChangedMessage = (oldAddress: string, newAddress: string): string =>
  `Consent was given for ${oldAddress}. Record new consent to email bills to ${newAddress}.`
// Every recipient must be the consented address (case-insensitive).
export const recipientsMatchConsent = (consentEmail: string | null | undefined, to: string[]): boolean => {
  const c = (consentEmail ?? '').trim().toLowerCase()
  return !!c && to.length > 0 && to.every((t) => t.trim().toLowerCase() === c)
}
